import { render, staticRenderFns } from "./InHospitalInDetailDispatch.vue?vue&type=template&id=d189ec76"
import script from "./InHospitalInDetailDispatch.vue?vue&type=script&lang=js"
export * from "./InHospitalInDetailDispatch.vue?vue&type=script&lang=js"
import style0 from "./InHospitalInDetailDispatch.vue?vue&type=style&index=0&id=d189ec76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports